import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import ForumIcon from "@mui/icons-material/Forum"; // Used as "Threads"-like icon (or replace if you have a Threads icon)
import LogoIcon from "../../assets/logo.png"; // Adjust path to your logo

const Footer = ({ mode }) => {
  const isLight = mode === "light";
  const textColor =  "#ccc";
  const bgColor =  "#1a1a1a";
  const iconColor =  "#f5f5f5";

  return (
    <Box sx={{ bgcolor: bgColor, py: 4, mt: 8 }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          {/* === Left Side: Logo, Name, Motto === */}
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box
                component="img"
                src={LogoIcon}
                alt="Olyvia Tech Logo"
                sx={{
                  width: 50,
                  height: "auto",
                  opacity: 0.8,
                }}
              />
              <Box>
                <Typography
                  variant="h6"
                  sx={{ color: textColor, fontWeight: 600 }}
                >
                  Olyvia Tech
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: textColor, fontStyle: "italic" }}
                >
                  One stop solution for technology
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* === Right Side: Social Icons === */}
          <Grid item xs={12} md="auto">
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" },
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <IconButton disableRipple sx={{ color: iconColor }}>
                <InstagramIcon />
              </IconButton>
              <IconButton disableRipple sx={{ color: iconColor }}>
                <WhatsAppIcon />
              </IconButton>
              <IconButton disableRipple sx={{ color: iconColor }}>
                <FacebookIcon />
              </IconButton>
              <IconButton disableRipple sx={{ color: iconColor }}>
                <LinkedInIcon />
              </IconButton>
              <IconButton disableRipple sx={{ color: iconColor }}>
                <EmailIcon />
              </IconButton>
              <IconButton disableRipple sx={{ color: iconColor }}>
                <ForumIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* === Bottom Text === */}
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography variant="body2" sx={{ color: textColor }}>
            © {new Date().getFullYear()} Olyvia Tech. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
